import * as React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import RadioButton from 'react-toolbox/lib/radio';
import { radioGroupFactory } from 'react-toolbox/lib/radio/RadioGroup';

import radioTheme from './Radio.scss';
import listRadioButtonTheme from './ListRadioButton.scss';
import theme from 'react-toolbox/lib/radio/theme.scss';
import { SizeEnum } from 'common/enums/UIEnums';
import coreIds from 'common/tests/core/coreIds.json';

const RADIO = 'OUTLINERADIO';
const LIST_RADIO_BUTTON = 'LIST_RADIO_BUTTON';

const RadioButtonComponent = props => {
    const {
        theme,
        className,
        invert,
        checked,
        size,
        'data-test-id': dataTestId,
        wrapWithDiv,
        radioColor,
        desc,
        ...others
    } = props;
    const sizeClass = SizeEnum.getSizeClass({ theme, size });
    return wrapWithDiv ? (
        <div data-test-id={dataTestId}>
            <RadioButton
                {...others}
                checked={checked}
                className={classnames(className, {
                    [theme.invert]: invert,
                    [sizeClass]: !!sizeClass,
                    [theme[radioColor]]: radioColor,
                    [theme.checked]: checked
                })}
                theme={theme}
            />
        </div>
    ) : (
        <>
            <RadioButton
                {...others}
                checked={checked}
                data-test-id={dataTestId || coreIds.radioBtn}
                className={classnames(className, {
                    [theme.invert]: invert,
                    [sizeClass]: !!sizeClass,
                    [theme[radioColor]]: radioColor,
                    [theme.checked]: checked
                })}
                theme={theme}
            />
            {desc && <span className={theme.desc}>{desc}</span>}
        </>
    );
};

const CustomThemedRadioButton = themr(RADIO, radioTheme)(RadioButtonComponent);
const ThemedRadioGroup = themr(
    RADIO,
    theme
)(radioGroupFactory(CustomThemedRadioButton));
const RadioGroupComponent = props => {
    const { theme, className, row, ...others } = props;
    return (
        <ThemedRadioGroup
            {...others}
            className={classnames(className, theme.radioGroup, {
                [theme.row]: row
            })}
            theme={theme}
        />
    );
};

const CustomThemedRadioGroup = themr(RADIO, radioTheme)(RadioGroupComponent);

const ThemedListRadioButton = themr(
    LIST_RADIO_BUTTON,
    listRadioButtonTheme
)(RadioButton);
const ThemedListRadioGroup = themr(
    RADIO,
    theme
)(radioGroupFactory(ThemedListRadioButton));

export default CustomThemedRadioButton;
export {
    CustomThemedRadioButton as RadioButton,
    ThemedListRadioButton as ListRadioButton,
    CustomThemedRadioGroup as RadioGroup,
    ThemedListRadioGroup as ListRadioGroup
};
